import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { register } from '@loyalup/core';
import { Layout, Checkbox, Button, Field, Form, Link, AuthPanel } from '@loyalup/ui';

import s from './Register.module.css';

const onSubmit = async (fields, locale, setLoading, setErrors, t) => {
  if (!fields.conds) {
    setErrors({ conds: t('необходимо ваше согласие') });
    return;
  }

  setLoading(true);
  setErrors({});
  const [ok, errors] = await register({ ...fields, locale });

  if (!ok) {
    setErrors(errors);
    setLoading(false);
    return;
  }

  window.location = '/';
};

const Register = () => {
  const [t, i18n] = useTranslation();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [fields, setFields] = useState({
    company_name: '',
    name: '',
    email: '',
    phone: '',
    password: '',
    conds: false,
  });

  return (
    <Layout center title={t('Регистрация')}>
      <AuthPanel mode="register">
        <div className={s.root}>
          <div className={s.header}>
            <h1>{t('Регистрация')}</h1>
          </div>
          <Form onSubmit={() => onSubmit(fields, i18n.language, setLoading, setErrors, t)}>
            <Field
              label={t('Компания')}
              name="company_name"
              type="text"
              disabled={loading}
              error={errors.company_name}
              autoComplete="new-company-name"
              autoFocus
              value={fields.company_name}
              onChange={company_name => setFields({ ...fields, company_name })}
              required
            />
            <Field
              label={t('Имя')}
              name="name"
              type="text"
              disabled={loading}
              error={errors.name}
              autoComplete="new-name"
              value={fields.name}
              onChange={name => setFields({ ...fields, name })}
              required
            />
            <Field
              label={t('Е-мейл')}
              name="email"
              type="email"
              disabled={loading}
              error={errors.email}
              autoComplete="new-email"
              value={fields.email}
              onChange={email => setFields({ ...fields, email })}
              required
            />
            <Field
              label={t('Пароль')}
              name="password"
              type="password"
              disabled={loading}
              error={errors.password}
              autoComplete="new-password"
              value={fields.password}
              onChange={password => setFields({ ...fields, password })}
              required
            />
            <Checkbox
              name="conds"
              disabled={loading}
              error={errors.conds}
              checked={fields.conds}
              onChange={conds => setFields({ ...fields, conds })}
            >
              {t('Я даю свое согласие на обработку персональных данных и согласен с условиями')}{' '}
              <Link component="a" to="/user-agreement" target="_blank">
                {t('Лицензионного договора')}
              </Link>
            </Checkbox>
            <Button type="submit" fixedWidth={200} center loading={loading}>
              {t('Зарегистрироваться')}
            </Button>
          </Form>
          <p className={s.hint}>
            {t('Уже есть аккаунт?')}
            &nbsp;
            <Link to="/login">{t('Войти')}</Link>
          </p>
        </div>
      </AuthPanel>
    </Layout>
  );
};

export default Register;
